<navigation-item-type-tag [type]="navigationItem.type"></navigation-item-type-tag>
<span
  class="ml-2 d-flex justify-content-center colum"
  style="flex-direction: column; color: var(--dark-base)"
  [class.type-tag-small]="navigationItem.isClickTroughPage"
>
  {{ navigationItem.name }}
</span>

<ng-content></ng-content>
